import { Listbox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid'

import MicroVolumeStimulusTypeIcon from 'components/Program/MicroVolumeConfig/MicroVolumeStimulusTypeIcon'

export default function MicroVolumeStimulusTypeDropdown({
    microVolumeStimulusTypeHashMap = {},
    microVolumeStimulusTypeId,
    setMicroVolumeStimulusTypeId
}) {
    if (
        microVolumeStimulusTypeHashMap === null 
        || Object.keys(microVolumeStimulusTypeHashMap).length === 0
    ) {
        return (
            <p>No micro volume config types found</p>
        )
    }

    return (
        <Listbox
            value={microVolumeStimulusTypeId}
            onChange={setMicroVolumeStimulusTypeId}
        >
            <div className='relative w-full'>
                <Listbox.Button className='relative flex h-10 w-full items-center cursor-pointer rounded-lg border border-gray-300 bg-white pl-3 pr-10 text-left text-sm shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 shadow-md'>
                    {(() => {
                        const selected = microVolumeStimulusTypeHashMap[microVolumeStimulusTypeId]

                        return (
                            <span className='flex items-center gap-x-2 text-sm'>
                                <span className='flex h-5 w-5 flex-shrink-0 items-center justify-center'>
                                    {selected && <MicroVolumeStimulusTypeIcon iconKey={selected.iconKey} />}
                                </span>
                                <span className='block truncate text-sm'>
                                    {selected ? selected.name : 'Select week type'}
                                </span>
                            </span>
                        )
                    })()}

                    <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                        <ChevronUpDownIcon className='h-5 w-5 text-gray-400' />
                    </span>
                </Listbox.Button>

                <Transition
                    as="div"
                    leave='transition ease-in duration-100'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <Listbox.Options className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none'>
                        {Object.entries(microVolumeStimulusTypeHashMap)
                            .sort(([, a], [, b]) => a.sortOrder - b.sortOrder)
                            .map(([typeId, microVolumeStimulusType]) => (
                                <Listbox.Option
                                    key={typeId}
                                    value={parseInt(typeId)}
                                    className={({ active }) =>
                                        `relative cursor-pointer select-none py-2 pl-3 pr-9 
                                        ${active ? 'bg-orange-50' : ''}`
                                    }
                                >
                                    {({ selected }) => (
                                        <>
                                            <span className='flex items-center gap-x-2'>
                                                <span className='flex h-5 w-5 flex-shrink-0 items-center justify-center'>
                                                    <MicroVolumeStimulusTypeIcon iconKey={microVolumeStimulusType.iconKey} />
                                                </span>
                                                <span className={`block truncate text-sm ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                    {microVolumeStimulusType.name}
                                                </span>
                                            </span>

                                            {selected &&
                                                <span className='absolute inset-y-0 right-0 flex items-center pr-2 text-orange-600'>
                                                    <CheckIcon className='h-5 w-5' />
                                                </span>
                                            }
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}
